import React, { useMemo } from "react";
import styles from "./ui.module.scss";
import Spinner from "../spinner";
import Head from "next/head";

export type TSmartHeader = {
  title: string;
  description?: string;
  children: any;
  spinner: boolean;
  image?: string;
};

const SmartHeader: React.FC<TSmartHeader> = ({
  title,
  description,
  children,
  spinner,
  image,
}) => {
  const titleParser = useMemo(() => {
    if (title?.length > 35) {
      return `${title.slice(0, 35)}...`;
    } else {
      return title;
    }
  }, [title]);

  const IWidth = "600";
  const IHeight = "315";

  const metas = useMemo(() => {
    return (
      <Head>
        <title>{titleParser} | DonorSearch.org</title>
        <meta property="og:title" content={titleParser} />
        <meta property="title" content={titleParser} />
        <meta property="twitter:card" content="summary_large_image" />
        {description && <meta property={"description"} content={description} />}
        {description && <meta name={"description"} content={description} />}
        {description && (
          <meta property={"og:description"} content={description} />
        )}
        {description && <meta name={"og:description"} content={description} />}
        {description && (
          <meta property="og:description" content={description} />
        )}
        {description && <meta name="description" content={description} />}
        {image && <meta property="vk:image" content={image} key="mainImage" />}
        {image && <meta property="og:image" content={image} key="mainImage" />}
        {image && <meta property="twitter:image" content={image} />}
        {image && <meta property="og:image:width" content={IWidth} />}
        {image && <meta property="og:image:height" content={IHeight} />}
        {image && <link rel="image_src" href={image} />}
      </Head>
    );
  }, [titleParser, description]);

  if (spinner) {
    return (
      <>
        {metas}
        <div className={styles.SmartHeader}>
          <Spinner toggled={true} />
        </div>
      </>
    );
  } else {
    return (
      <>
        {metas} {children}
      </>
    );
  }
};

export default SmartHeader;
